document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".accordion-container");

  sections.forEach((section) => {
    const buttons = section.querySelectorAll(".accordion-trigger");
    const mediaBox = section.querySelector(".accordion-media");

    // On page load: show first open item’s panel and media
    const openOne = section.querySelector(
      '.accordion-trigger[aria-expanded="true"]'
    );
    if (openOne) {
      const panel = openOne.nextElementSibling;
      if (panel) {
        panel.setAttribute("aria-hidden", "false");
      }

      const type = openOne.getAttribute("data-media-type");
      const src = openOne.getAttribute("data-media-src");
      const mime = openOne.getAttribute("data-media-mime");
      const poster = openOne.getAttribute("data-media-poster");

      let media = "";

      if (type === "video") {
        media = `
          <video class="accordion-media-item has-rounded-shadow" playsinline autoplay loop muted preload="auto" poster="${poster}">
            <source src="${src}" type="${mime}">
          </video>`;
      } else {
        media = `<img class="accordion-media-item" src="${src}" alt="">`;
      }

      mediaBox.innerHTML = media;
    }

    // When a button is clicked: toggle accordion and update media
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        // Collapse all panels
        buttons.forEach((b) => {
          b.setAttribute("aria-expanded", "false");
          const panel = b.nextElementSibling;
          if (panel) {
            panel.setAttribute("aria-hidden", "true");
          }
        });

        // Expand selected panel
        btn.setAttribute("aria-expanded", "true");
        const panel = btn.nextElementSibling;
        if (panel) {
          panel.setAttribute("aria-hidden", "false");
        }

        // Update media display on the right
        const type = btn.getAttribute("data-media-type");
        const src = btn.getAttribute("data-media-src");
        const mime = btn.getAttribute("data-media-mime");
        const poster = btn.getAttribute("data-media-poster");

        let media = "";

        if (type === "video") {
          media = `
            <video class="accordion-media-item has-rounded-shadow" playsinline autoplay loop muted preload="auto" poster="${poster}">
              <source src="${src}" type="${mime}">
            </video>`;
        } else {
          media = `<img class="accordion-media-item" src="${src}" alt="">`;
        }

        mediaBox.innerHTML = media;
      });
    });
  });
});
